import Head from 'next/head';
import type { LocalBusiness } from 'schema-dts';

import { getAbsoluteUrl, renderSchemas } from '~/util/seoUtils';

interface SeoHeadProps {
  title: string;
  description: string;
  imageUrl?: string;
  canonicalUrl?: string;
  keywords?: string;
  schemas?: LocalBusiness[];
  noindex?: boolean;
}

const SeoHead = ({
  title = 'Explore Vendors - Zola',
  description,
  keywords,
  imageUrl,
  canonicalUrl,
  schemas,
  noindex = false,
}: SeoHeadProps): JSX.Element => (
  <Head>
    <title key="title">{title}</title>
    {description && <meta name="description" content={description} key="meta-description" />}
    {keywords && <meta name="keywords" content={keywords} key="meta-keywords" />}
    {noindex && <meta name="robots" content="noindex" key="meta-robots" />}
    <meta property="og:title" content={title} />
    {description && <meta property="og:description" content={description} />}
    {imageUrl && <meta property="og:image" content={imageUrl} />}
    <meta property="og:type" content="website" />
    {canonicalUrl && <meta property="og:url" content={getAbsoluteUrl(canonicalUrl)} />}
    <meta property="og:locale" content="en_US" />
    <meta property="og:site_name" content="zola.com" />
    <meta property="og:phone_number" content="1-408-657-ZOLA" />
    <meta property="fb:app_id" content="215495315286955" />
    <meta name="twitter:title" content={title} />
    {description && <meta name="twitter:description" content={description} />}
    {imageUrl && <meta name="twitter:image" content={imageUrl} />}
    {imageUrl && <meta name="twitter:card" content="summary_large_image" />}
    <meta name="twitter:site" content="@zola" />
    <meta name="twitter:creator" content="@zola" />
    {canonicalUrl && <link rel="canonical" href={getAbsoluteUrl(canonicalUrl)} key="canonical" />}
    {schemas && renderSchemas(schemas)}
  </Head>
);

export default SeoHead;
